import { loadStripe, type Stripe } from '@stripe/stripe-js';
import { api } from './api.ts';

export interface StripeConfig {
  configured: boolean;
  mode: 'test' | 'live' | null;
  publishableKey: string | null;
  webhookConfigured: boolean;
}

let configPromise: Promise<StripeConfig> | null = null;
let stripePromise: Promise<Stripe | null> | null = null;

/** Clés publiques demandées au serveur : elles ne sont jamais codées en dur dans le navigateur. */
export function getStripeConfig(): Promise<StripeConfig> {
  configPromise ??= api.get<StripeConfig>('/payments/config');
  return configPromise;
}

export async function getStripe(): Promise<Stripe | null> {
  const config = await getStripeConfig();
  if (!config.configured || !config.publishableKey) return null;
  stripePromise ??= loadStripe(config.publishableKey, { locale: 'fr' });
  return stripePromise;
}

export const PAYMENT_ERRORS: Record<string, string> = {
  STRIPE_NOT_CONFIGURED: 'Le paiement par carte n’est pas encore activé sur Mon Extra. Réessayez bientôt.',
  CARD_REQUIRED: 'Enregistrez d’abord une carte bancaire.',
  CARD_DECLINED: 'La carte a été refusée. Essayez une autre carte.',
  CARD_IN_USE: 'Cette carte sert à payer une mission réservée : remplacez-la plutôt que de la retirer.',
  PAYMENT_ALREADY_EXISTS: 'Le paiement de cette mission est déjà réservé.',
};
